import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './UserChangePasswordModal.css';
import { Modal } from 'react-bootstrap';
import exit from '../../../assets/icons/cross-DARK-32x32.png';
import { I18n } from 'react-redux-i18n';
import Button from '../Button';
import Input from '../Input';
import regex from '../../../utils/regex';

class UserChangePasswordModal extends Component {
  static defaultProps;

  render() {
    const hasInvalidCharsInPassword =
      this.props.password.inputValue &&
      regex.invalidPasswordCharsRegex.test(this.props.password.inputValue);
    const hasInvalidCharsInRepeatPassword =
      this.props.repeatPassword.inputValue &&
      regex.invalidPasswordCharsRegex.test(
        this.props.repeatPassword.inputValue,
      );
    const hasInvalidCharsInCurrentPassword =
      this.props.currentPassword.inputValue &&
      regex.invalidPasswordCharsRegex.test(
        this.props.currentPassword.inputValue,
      );
    const isPasswordValid =
      this.props.password.inputValue &&
      regex.passwordRegex.test(this.props.password.inputValue);

    return (
      <Modal
        show={this.props.show}
        dialogClassName="user-change-password-modal"
        onHide={this.props.onHide}
      >
        <Modal.Header>
          <span className="material-symbols-filled">{'lock'}</span>
          <p className="modal-title">{I18n.t('users.changePassword')}</p>
        </Modal.Header>
        <Modal.Body>
          <form
            style={{ width: '100%' }}
            onSubmit={(event) => event.preventDefault()}
          >
            <input
              type="text"
              name="username"
              autoComplete="username"
              value={this.props.user?.email || ''}
              readOnly
              tabIndex={-1}
              aria-hidden="true"
              style={{ display: 'none' }}
            />
            <Input
              label={I18n.t('users.actualPassword')}
              name="currentPassword"
              value={this.props.currentPassword}
              change={this.props.change}
              placeholder={I18n.t('users.currentPassword')}
              type={'password'}
              autocomplete="current-password"
            />
            <Input
              label={I18n.t('users.newPass')}
              name="password"
              value={this.props.password}
              change={this.props.change}
              placeholder={I18n.t('users.newPassword')}
              type={'password'}
              autocomplete="new-password"
              ignoreDirty
            />
            <span className="notify">{I18n.t('users.tooltipPassword')}</span>
            <Input
              label={I18n.t('users.rePassword')}
              name="repeatPassword"
              value={this.props.repeatPassword}
              change={this.props.change}
              placeholder={I18n.t('users.repeatPassword')}
              type={'password'}
              autocomplete="new-password"
              ignoreDirty
            />
          </form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="text-link-button"
            text={I18n.t('buttons.cancel')}
            onClick={this.props.onHide}
          />
          <Button
            className="primary"
            text={I18n.t('buttons.change')}
            onClick={() => {
              this.props.action(
                this.props.password.inputValue,
                this.props.currentPassword.inputValue,
              );
              this.props.onHide();
            }}
            disabled={
              !this.props.currentPassword.inputValue ||
              !this.props.password.inputValue ||
              !isPasswordValid ||
              this.props.password.inputValue !==
                this.props.repeatPassword.inputValue ||
              hasInvalidCharsInPassword ||
              hasInvalidCharsInRepeatPassword ||
              hasInvalidCharsInCurrentPassword
            }
          />
        </Modal.Footer>
      </Modal>
    );
  }
}

UserChangePasswordModal.defaultProps = {};
UserChangePasswordModal.propTypes = {
  show: PropTypes.bool,
  onHide: PropTypes.func,
};

export default UserChangePasswordModal;
